import React from 'react';
import { api } from '../../../api';
import { PerformanceTabContent } from '../PerformanceTabContent/PerformanceTabContent';
import { FetchParams, PerformanceTabs } from '../performanceUtils';
import { chaptersColumns, chaptersHeaders } from '../tableUtils/columns/chaptersColumns';

export interface PerformanceTabContentProps {
  pageSize: number,
}

export function ChaptersPerformanceTabContent(props: PerformanceTabContentProps) {
  const { pageSize } = props;

  const fetchPerformanceData = async (
    params: FetchParams,
    signal: AbortSignal,
  ) => {
    const response = await api.get(
      '/v2/analytics/performance/chapters',
      { params, signal },
    );
    return response.data;
  };

  return (
    <PerformanceTabContent
      tabTitle={PerformanceTabs.Chapters}
      csvHeaders={chaptersHeaders}
      columns={chaptersColumns}
      getData={fetchPerformanceData}
      pageSize={pageSize}
    />
  );
}
